import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { intlLiToYuan } from 'utils/money';
import Style from './style';

export const TotalInfo = (props) => {
  const { currency, totalPrice, totalLineItemsPrice, totalDiscount, multiCurrencyInfo } = props;
  const intl = useIntl();
  const discount = ((totalPrice / totalLineItemsPrice) * 10).toFixed(2);

  return (
    <Style className='pay-total'>
      {/* 小记 */}
      <div className='item-block'>
        <span className='main-title'>
          <FormattedMessage id='order.address.total_text' />
        </span>
        <span className='sub-title total-goods-price'>
          {intlLiToYuan({
            currency,
            value: totalLineItemsPrice,
          })}
        </span>
      </div>

      {/* 展示非免运费折扣信息 */}
      {!!totalDiscount && (
        <div className='item-block discount-block'>
          <div className='f-js-ac item-block-item'>
            <span className='main-title'>
              <FormattedMessage id='discount_title' />
              {/* 折扣 */}
            </span>

            <div className='shipping-price total-goods-price'>
              -
              {intlLiToYuan({
                currency,
                value: totalDiscount,
              })}
            </div>
          </div>
          <div className='ship-free-discount-code'>
            <svg className='ship-free-discount-code-icon' aria-hidden='true'>
              <use xlinkHref='#iconicon_discount' />
            </svg>
            <p className='ship-free-discount-text'>
              {intl.formatMessage(
                {
                  id: 'd3fd517f819c48a8a345cb6f93e6a2de',
                  defaultMessage: `${discount}折`,
                },
                {
                  discount,
                },
              )}
            </p>
          </div>
        </div>
      )}

      {/* 总计 */}
      <div className='item-block sum-count-wrapper skiptranslate'>
        <div className='font-light'>
          <FormattedMessage id='order.address.total' />
        </div>
        <div className='layout-cell-right font-light skiptranslate'>
          <div className='total-price'>
            {intlLiToYuan({
              currency,
              value: totalPrice,
            })}
          </div>
        </div>
      </div>
      {/* 设置了多币种才展示这部分 */}
      {multiCurrencyInfo?.currency && (
        <div className='layout-cell-right font-light'>
          <div className='multi-currency-total-price'>
            {intlLiToYuan({
              currency,
              value: totalPrice,
              multiCurrencyInfo,
            })}
          </div>
          <div className='multi-currency-total-price-desc'>
            {intl.formatMessage({
              defaultMessage: '金额可能会因汇率而异',
              id: 'c03815036df94ee686046643ff35e65c',
            })}
          </div>
        </div>
      )}
    </Style>
  );
};
